
import './ModalButtons.css'
import { IoClose } from 'react-icons/io5';
import { useState, useEffect } from 'react';


const ModalButtons = ({setShowModalButtons, status , keyOfTrip , handleStatusOfOrderToSend}) => {
        // Odešle objednávku a zavře
        const handleStatusOfOrder = (keyOfTrip, status, time) => {
            handleStatusOfOrderToSend(keyOfTrip, status, time)
            setShowModalButtons(false)
        }

        // VYBER MODALU
        return (
        <div className='ModalButtons'>
       
            <IoClose size={30} color={"grey"} className="closeIcon" onClick={()=>setShowModalButtons(false)}/>
            <div className="titleOfModal">
                <h3>Za jak dlouho dorazíte? </h3>
            </div>

  
            <section className='listOfChoice'>
                <br />
             
                 <div className="oneChoice green1" 
                    style={status === 1 ? { display: 'flex', backgroundColor: 'green'}: {visibility: 'hidden'} }
                     onClick={() => handleStatusOfOrder(keyOfTrip, 2, 10)}
                    >
                    <p className="">10 Min</p>
                </div>
          
            
                <div className="oneChoice green2" 
                    style={status === 1 ? { display: 'flex', backgroundColor: 'green'}: {visibility: 'hidden'} }
                    onClick={() => handleStatusOfOrder(keyOfTrip, 2 , 15)} 
                >
                    <p className="">15 Min</p>
                </div>
          
                <div className="oneChoice green3" 
                    style={status === 1 ? { display: 'flex', backgroundColor: 'green'}: {visibility: 'hidden'} }
                    onClick={() => handleStatusOfOrder(keyOfTrip, 2 , 20)} 
                >
                    <p className="">20 Min</p>
                </div>
         
            
                <div className="oneChoice green4" 
                    style={status === 1 ? { display: 'flex', backgroundColor: 'green'}: {visibility: 'hidden'} }
                    onClick={() => handleStatusOfOrder(keyOfTrip, 2 , 25)} 
                >
                    <p className="">25 Min</p>
                </div>

                <div className="oneChoice green1" 
                    style={status === 2 ? { visibility: 'visible', backgroundColor: "green"}: {visibility: 'hidden'}  }
                    onClick={() => handleStatusOfOrder(keyOfTrip, 3)} 
                >
                    <p className="">Jsem na místě</p>
                </div>

                <div className="oneChoice violet" 
                    style={status === 2 ? { display: 'flex'}: {visibility: 'hidden'} }
                    onClick={() => handleStatusOfOrder(keyOfTrip, 1)} 
                >
                    <p className="">Změna</p>
                </div>

                <div className="oneChoice yellow" 
                    style={status >= 2 ? { visibility: 'visible', backgroundColor: "orange"}: {visibility: 'hidden'}  }
                    onClick={() => handleStatusOfOrder(keyOfTrip, 5)} 
                >
                    <p className="">Hotovo</p>
                </div>
             
 
                <br />
                <div 
                    className="oneChoice light" onClick={() => handleStatusOfOrder(keyOfTrip, 7)} 
                    style={status >= 2 && status !== 7 ? { visibility: 'visible'}: {visibility: 'hidden'}  }
                >
                    <p className="">Čekací doba min.</p>
                </div>
                <div 
                    className="oneChoice light" onClick={() => handleStatusOfOrder(keyOfTrip, 4)} 
                    style={status === 7 ? { visibility: 'visible'}: {visibility: 'hidden'}  }
                >
                    <p className="">Vypnout časovač</p>
                </div>
                <br />
                <div className="oneChoice red" onClick={() => handleStatusOfOrder(keyOfTrip, 6)} >
                    <p className="">STORNO - s omluvenkou</p>
                </div>
    
                <div className="oneChoice blackCol" onClick={() => handleStatusOfOrder(keyOfTrip, 10)} >
                    <p className="">BAN</p>
                </div>
            </section>

             
        </div>
        )
}

export default ModalButtons